/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Edit_Contract_SavedInputs */



/**
* | output |
* | --- |
* | "Contract updated." |
*
* @param {Partner_Edit_Contract_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_saved = /** @type {((inputs?: Partner_Edit_Contract_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertrag aktualisiert.")
	return /** @type {LocalizedString} */ ("Contract updated.")
});